import { FieldErrors, FieldValues } from 'react-hook-form/dist/types';

export function getValidationClassForInput(
	fieldName: string,
	touchedFields: Partial<Readonly<Record<string, any>>>,
	errors: FieldErrors<FieldValues>,
	baseCssClassPostFix = '',
) {
	const baseClass = 'input-basic' + baseCssClassPostFix;
	if (Object.keys(touchedFields).indexOf(fieldName) < 0) {
		return baseClass;
	}
	return baseClass + (errors[fieldName] ? ' -error' : ' -valid');
}

export const scrollToFirstInvalidField = (
	errors: FieldErrors<any>,
	defaultFocusElementId: string | undefined = undefined,
) => {
	if (document && window) {
		const inputs = document.getElementsByName(Object.keys(errors)[0]);

		if (inputs.length > 0) {
			inputs[0].parentElement!.scrollIntoView();
			window.scrollBy(0, -100);
		} else if (defaultFocusElementId) {
			const defaultElement = document.getElementById(defaultFocusElementId);
			if (defaultElement) {
				defaultElement.scrollIntoView();
			}
		}
	}
};
